import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import { getOkey } from '@/api/tools.js'
Vue.use(Router)
const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // 首页
    {
      path: '/',
      name: 'index',
      redirect: '/index',
      component: Layout,
      children: [
        {
          path: '/index',
          component: () => import('@/views/index.vue')
        },
        // 隐私政策
        {
          path: '/privacy_policy',
          name: 'privacy_policy',
          component: () => import('@/views/other/privacy_policy.vue'),
        },
        // 法律声明
        {
          path: '/legal_statement',
          name: 'legal_statement',
          component: () => import('@/views/other/legal_statement.vue'),
        }
      ]
    },
    // 小森家族
    { 
      path: '/family',
      name: 'family',
      redirect: '/family/index',
      component: Layout,
      children: [
        // 首页
        {
          path: 'index',
          component: () => import('@/views/family/index.vue')
        },
        // 康芯板
        {
          path: 'kangxin',
          component: () => import('@/views/family/kangxin/index.vue')
        },
        // 安芯板
        {
          path: 'anxin',
          component: () => import('@/views/family/anxin/index.vue')
        },
        // 科创板
        {
          path: 'kechuang',
          component: () => import('@/views/family/kechuang/index.vue')
        },
        // 晶瓷板
        {
          path: 'jingci',
          component: () => import('@/views/family/jingci/index.vue')
        },
        // 绿芯胶
        {
          path: 'lvxin',
          component: () => import('@/views/family/lvxin/index.vue')
        },
        // 辅材
        {
          path: 'fucai',
          component: () => import('@/views/family/fucai/index.vue'),
        },
        // 辅材详情
        {
          path: 'fucai/info',
          component: () => import('@/views/family/fucai/info.vue')
        }
      ]
    },
    // 小森案例
    {
      path: '/case',
      name: 'case',
      redirect: '/case/index',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/case/index.vue')
        }
      ]
    },
    // 解决方案
    {
      path: '/solution',
      name: 'solution',
      redirect: '/solution/index',
      component: Layout,
      children: [
        {
          path: 'index',
          component: () => import('@/views/solution/index.vue')
        }
      ]
    },
    // 小森服务
    {
      path: '/serve',
      redirect: '/serve/index',
      component: Layout,
      children: [
        // 首页
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/serve/index.vue'),
        },
        // 设计之家
        {
          path: 'designer',
          name: 'designer',
          component: () => import('@/views/serve/designer/index.vue')
        },
        // 小森有礼
        {
          path: 'activity',
          name: 'activity',
          component: () => import('@/views/serve/activity/index.vue')
        },
        // 家居焕新
        {
          path: 'renew',
          name: 'renew',
          component: () => import('@/views/serve/renew/index.vue')
        },
        // 门店查询
        {
          path: 'store',
          name: 'store',
          component: () => import('@/views/serve/store/index.vue')
        },
        // 查授权家具厂
        {
          path: 'factory',
          name: 'factory',
          component: () => import('@/views/serve/factory/index.vue')
        },
        // 防伪查询
        {
          path: 'security',
          name: 'security',
          component: () => import('@/views/serve/securityCheck/index.vue')
        },
        // 资料下载
        {
          path: 'download',
          name: 'download',
          component: () => import('@/views/serve/downLoad/index.vue')
        },
        // 定制预约
        {
          path: 'cusAppointment',
          name: 'cusAppointment',
          component: () => import('@/views/serve/cusAppointment/index.vue')
        },
        // 常见问题
        {
          path: 'problem',
          name: 'problem',
          component: () => import('@/views/serve/problem/index.vue')
        }
      ]
    },
    // 走进小森
    {
      path: '/goin',
      redirect: '/goin/im',
      component: Layout,
      children: [
        // 我是小森
        {
          path: 'im',
          name: 'im',
          component: () => import('@/views/goin/im/index.vue'),
        },
        // 小森荣誉
        {
          path: 'honur',
          name: 'honur',
          component: () => import('@/views/goin/honur/index.vue')
        },
        // 合作伙伴
        {
          path: 'partners',
          name: 'partners',
          component: () => import('@/views/goin/partners/index.vue')
        },
        // 小森新闻
        {
          path: 'news',
          name: 'news',
          component: () => import('@/views/goin/news/index.vue')
        },
        {
          path: 'news/details/:id',
          name: 'details',
          component: () => import('@/views/goin/news/details.vue')
        }
      ]
    },
    // 加入我们
    {
      path: '/joinus',
      redirect: '/joinus/recruit',
      component: Layout,
      children: [
        // 招聘信息
        {
          path: 'recruit',
          name: 'recruit',
          component: () => import('@/views/joinus/recruit/index.vue')
        },
        // 招聘信息详情
        {
          path: 'recruit/info',
          component: () => import('@/views/joinus/recruit/info.vue')
        },
        // 招商加盟
        {
          path: 'merchants',
          component: () => import('@/views/joinus/merchants/index.vue')
        },
        // 项目合作
        {
          path: 'project',
          name: 'project',
          component: () => import('@/views/joinus/project/index.vue')
        }
      ]
    },
    {
      path: '/test',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/test/index.vue')
        }
      ]
    },
    {
      path: '/mine',
      component: Layout,
      redirect: '/mine/index',
      children: [
        {
          path: 'index',
          name: 'index',
          component: () => import('@/views/mine/index.vue')
        },
        {
          path: 'recommend',
          name: 'recommend',
          component: () => import('@/views/mine/recommend.vue')
        },
      ]
    }
  ]
})


const needLoginRouter = ['/serve/cusAppointment', '/joinus/merchants', '/joinus/project']
// 路由守卫
router.beforeEach((to, from, next) => {
  const okey = localStorage.getItem('okey')
  const odeskey = localStorage.getItem('odeskey')
  if (!okey || !odeskey) {
    getOkey().then(async res => {
      if (res.result == 1) {
        localStorage.setItem('okey', res.okey)
        localStorage.setItem('odeskey', res.odeskey)
      } else {
        console.log(res.msg)
      }
      next()
    })
  } else {
    next()
  }
})

export default router
